import React from 'react'
import {Outlet} from 'react-router-dom'
import '../css/public/sellerpolicy.css'

const Sellerpolicies = () => {
  return (
    <Outlet />
  )
}

export default Sellerpolicies
